// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"b90c7f2e","286":"16ac60dc","511":"de67281f","676":"ba046536","680":"b246e449","849":"f72569c7"}[chunkId] + ".chunk.js";
};